<div class="row" style="width: 100%">
    <div class="col-md-6">
        <div class="card card-custom gutter-b card-stretch">
            <div class="card-body">
                <app-instance-item-reports
                    [reportData]="defaultReport"
                    type="Default Reports"
                    *ngIf="defaultReport || customReport"
                    (isreportChecked)="isreportCheckedHandler($event)"
                ></app-instance-item-reports>
            </div>
        </div>
    </div>
    <div class="col-md-6">
        <div class="card card-custom gutter-b card-stretch">
            <div class="card-body">
                <app-instance-item-reports
                    [reportData]="customReport"
                    type="Custom Reports"
                    *ngIf="defaultReport || customReport"
                    (isreportChecked)="isreportCheckedHandler($event)"
                ></app-instance-item-reports>
            </div>
        </div>
    </div>
</div>
